import type { GetMissionsFromMapDto } from '../../api/api.g';
import type { MapLocation } from '../../models/MapModels';

export const INITIAL_DISCOVERY_RADIUS_KM = 30;

export function getRadiusBounds(center: MapLocation, radiusKm = INITIAL_DISCOVERY_RADIUS_KM) {
  const radians = radiusKm / 6371;
  const latDelta = radians * 180 / Math.PI;
  const lngDelta = Math.asin(Math.min(1, Math.sin(radians) / Math.cos(center.lat * Math.PI / 180))) * 180 / Math.PI;
  const crossesDateLine = center.lng - lngDelta < -180 || center.lng + lngDelta > 180;
  return {
    northEast: { lat: Math.min(85, center.lat + latDelta), lng: crossesDateLine ? 180 : center.lng + lngDelta },
    southWest: { lat: Math.max(-85, center.lat - latDelta), lng: crossesDateLine ? -180 : center.lng - lngDelta },
  };
}

export function getInitialDiscoveryBounds(center: MapLocation, missions: GetMissionsFromMapDto[] = []) {
  const distances = missions.filter(mission => !mission.isPinned && Number.isFinite(mission.distance) && mission.distance >= 0)
    .map(mission => mission.distance / 1000);
  const nearest = distances.length ? Math.min(...distances) : 0;
  // Preserve sparse-area discovery, without framing distant Always show outliers.
  const radius = nearest > INITIAL_DISCOVERY_RADIUS_KM ? nearest + 20 : INITIAL_DISCOVERY_RADIUS_KM;
  return getRadiusBounds(center, radius);
}
